import { Link, NavLink, useNavigate } from "react-router-dom";
import { Wrench, LogOut, Search, History } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Logo = () => (
  <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
    <span className="grid place-items-center h-8 w-8 bg-primary text-white rounded-sm transition-transform duration-300 group-hover:rotate-45">
      <Wrench className="h-4 w-4 -rotate-45" />
    </span>
    <span className="font-display text-2xl font-extrabold tracking-wide uppercase">
      Torque<span className="text-primary">Search</span>
    </span>
  </Link>
);

const navCls = ({ isActive }) =>
  `flex items-center gap-2 px-3 py-2 text-sm rounded-sm transition-colors ${
    isActive ? "text-white bg-secondary" : "text-muted-foreground hover:text-white"
  }`;

export const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-[#0B0F17]/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Logo />
        {user ? (
          <div className="flex items-center gap-1 sm:gap-3">
            <NavLink to="/app" end className={navCls} data-testid="nav-search">
              <Search className="h-4 w-4" /> <span className="hidden sm:inline">AI Search</span>
            </NavLink>
            <NavLink to="/app/history" className={navCls} data-testid="nav-history">
              <History className="h-4 w-4" /> <span className="hidden sm:inline">History</span>
            </NavLink>
            <span className="hidden md:block text-xs text-muted-foreground font-mono truncate max-w-[160px]" data-testid="header-user-email">
              {user.email}
            </span>
            <Button
              variant="ghost"
              size="icon"
              data-testid="logout-btn"
              onClick={async () => { await logout(); navigate("/"); }}
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        ) : (
          <Button asChild className="rounded-sm font-semibold hover:bg-orange-600 hover:text-white" data-testid="header-signin-btn">
            <Link to="/login">Sign in</Link>
          </Button>
        )}
      </div>
    </header>
  );
};
